<template>
  <router-view />
</template>

<script>
export default {
  name: 'relatoriosHome',
}
</script>
